/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 * @format
 */

'use strict';

function isPromise(p) {
  return !!p && typeof p.then === 'function';
}

module.exports = isPromise;


//////////////////
// WEBPACK FOOTER
// ./~/relay-runtime/lib/isPromise.js
// module id = 2607
// module chunks = 3